import React from "react";
import { NavLink, Link } from "react-router-dom";

import GlobalData from "../../context/globaldata";

import Sort from "../../components/brews/Sort";
import BrewList from "../../components/BrewList";

class Brews extends React.PureComponent {
  static contextType = GlobalData;

  state = {
    collapsed: false,
    userBrews: [],
    filteredBrews: [],
    hasLoaded: false,
    filter: '',
    searchValue: '',
    sort: 'brew_date',
    sortDirection: 'desc',
  }

  getBrews = () => {
    this.defaultQuery = this.context.db.collection('brews').where('user', '==', this.context.currentUser.uid);

    if(this.props.brewsFilter) {
      this.databaseSnapshot = this.defaultQuery.where(this.props.brewsFilter, '==', true).orderBy(this.state.sort, this.state.sortDirection).onSnapshot((querySnapshot) => {
        this.processBrews(querySnapshot);
      });
    } else {
      this.databaseSnapshot = this.defaultQuery.where('trashed', '==', false).orderBy(this.state.sort, this.state.sortDirection).onSnapshot((querySnapshot) => {
        this.processBrews(querySnapshot);
      });
    }
  }

  searchBrews = (event) => {
    var updatedList = this.state.userBrews;

    updatedList = updatedList.filter((item) => {
      return item.name.toLowerCase().search(
        event.target.value.toLowerCase()) !== -1;
    });

    this.setState({
      searchValue: event.target.value,
      filteredBrews: updatedList
    })
  }

  changeSort = (type) => {
    var tempDirection = this.state.sortDirection;

    if(type === this.state.sort) {
      tempDirection = this.state.sortDirection === 'asc' ? 'desc' : 'asc';
    };

    this.setState({
      sort: type,
      sortDirection: tempDirection
    }, () => {

      if(this.props.brewsFilter) {
        this.databaseSnapshot = this.defaultQuery.where(this.props.brewsFilter, '==', true).orderBy(this.state.sort, this.state.sortDirection).onSnapshot((querySnapshot) => {
          this.processBrews(querySnapshot);
        });
      } else {
        this.databaseSnapshot = this.defaultQuery.where('trashed', '==', false).orderBy(this.state.sort, this.state.sortDirection).onSnapshot((querySnapshot) => {
          this.processBrews(querySnapshot);
        });
      }
    });
  }

  clearTrash = () => {
    const trashedBrews = this.state.userBrews.filter(brew => brew.trashed === true);
    var brewCount = 0;

    if(window.confirm(`Are you sure you want to delete all ${trashedBrews.length} thrashed brews? This action can't be undone!`)) {
      trashedBrews.forEach(brew => {
        this.context.db.collection('brews').doc(brew.uid).delete().then(() => {
          brewCount++;

          if(brewCount === trashedBrews.length) {
            this.context.addNotification('Trash emptied', 'All trashed brews have been permanently deleted', 'default', 'right', 'bottom-right');
          }
        }).catch((error) => {
          this.context.addNotification('Error', 'There was an error while trying to remove the brews, try again later.', 'danger', 'right', 'bottom-right');
        });
      });
    }
  }

  processBrews(data) {
    let brews = [];

    data.forEach(doc => {
      brews.push({ ...doc.data(), uid: doc.id })
    })

    this.setState({
      userBrews: brews,
      filteredBrews: brews,
      hasLoaded: true
    });
  }

  componentDidMount() {
    if(this.context.currentUser) {
      this.getBrews(this.props.brewsFilter);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.filter !== prevState.filter) {
      this.databaseSnapshot(); // Stop snapshot connection
      this.getBrews(this.state.filter);
    }

    if(this.props.brewsFilter !== prevProps.brewsFilter) {
      this.setState({
        filter: this.props.brewsFilter
      });
    }
  }

  componentWillUnmount() {
    if(this.hasOwnProperty('databaseSnapshot')) {
      this.databaseSnapshot(); // Stop snapshot connection
    }
  }

  render() {

    return (
      <aside className={ `brews ${ this.state.hasLoaded ? 'is-ready' : '' } ${ this.state.collapsed ? 'is-collapsed' : '' } ${ this.context.minifiedSidebar ? 'has-minified-sidebar' : '' }` }>
        <header className="brews-header">
          <div className="brews-header__top">
            <h1 className="brews-header__heading">
              { this.props.brewsFilter ? `${ this.props.brewsFilter} brews` : 'All brews' }
            </h1>
            <button
              className={`button button--danger button--rounded ${ this.props.url === '/brews/add' ? 'is-disabled' : '' } ${ this.state.filter === 'trashed' ? 'is-visible' : '' }`}
              onClick={ this.clearTrash }
            >
              <i className="material-icons">delete_forever</i>
            </button>
            <NavLink
              className={`button button--primary button--rounded ${ this.props.url === '/brews/add' ? 'is-disabled' : '' } ${ this.state.filter !== 'trashed' ? 'is-visible' : ''}`}
              to='/brews/add'
            >
              <i className="material-icons">add</i>
            </NavLink>
          </div>

          <Sort
            sortDirection={ this.state.sortDirection }
            sort={ this.state.sort }
            changeSort={ this.changeSort }
          />
        </header>

        <div className="search">
          <input className="search__input" type="text" name="searchValue" placeholder="Search by name, varietal,  type, etc." value={ this.state.searchValue } onChange={ this.searchBrews } />
          <div className="search__button">
            <i className="material-icons">search</i>
          </div>
        </div>

        <section className="brews__container">
          { this.state.hasLoaded ?
            (
              this.state.userBrews.length > 0 ? (
                this.state.filteredBrews.length > 0 ? (
                  // <Scrollbar>
                    <BrewList
                      brews={ this.state.filteredBrews }
                      db={ this.context.db }
                      sort={ this.state.sort }
                      activeBrewId={ this.props.params.brewId }
                    />
                  // </Scrollbar>
                ) : (
                  <div className="brews__message">
                    <div>We can't find any brews matching your search. <Link to='/brews/add'>Add a brew</Link> instead?</div>
                  </div>
                )
              ) : (
              <div className="brews__message">
                { this.state.filter === 'trashed' && this.state.userBrews.length === 0 ? (
                  <div>Look at you being all tidy, your parents must be so proud of you!</div>
                ) : (
                  <div>It looks like you have no brews, <Link to='/brews/add'>click here</Link> to add one!</div>
                ) }
              </div>
              )
            ) : (
              <div className="brews__loader"></div>
            )
          }
        </section>
      </aside>
    );
  }
}

export default Brews;
